import { ArrowUpRight, Clock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";

import { openCookieSettings } from "@/components/landing/CookieConsent";
import { Arrow } from "@/components/landing/icons";
import { TrustBadge } from "@/components/landing/TrustBadge";
import { SEGMENTS } from "@/pages/siteContent";

const SITE = [["#methode", "Notre méthode"], ["#avis", "Avis clients"], ["#faq", "Questions fréquentes"], ["#etude", "Étude gratuite"]];

export const LandingFooter = ({ logo, labels }) => (
  <footer className="lp-foot" data-testid="site-footer">
    <div className="lp-wrap">
      <div className="lp-foot-card">
        <div className="lp-foot-brand">
          <Link to="/" data-testid="footer-logo-link"><img src={logo} alt="Airthermo — Cabinet de courtage énergie" className="lp-foot-logo" data-testid="footer-logo" /></Link>
          <p>Cabinet de courtage en énergie : nous finançons et coordonnons l'installation de pompes à chaleur collectives grâce aux Certificats d'Économies d'Énergie.</p>
          {labels}
          <TrustBadge />
        </div>
        <nav className="lp-foot-col" aria-label="Pour qui">
          <h4>Pour qui</h4>
          {SEGMENTS.map((s) => <Link key={s.slug} to={`/pompe-a-chaleur/${s.slug}`} data-testid={`footer-seg-${s.slug}`}>{s.label}<ArrowUpRight size={13} /></Link>)}
        </nav>
        <nav className="lp-foot-col" aria-label="Le site">
          <h4>Le site</h4>
          <Link to="/le-cabinet" data-testid="footer-cabinet">Le cabinet<ArrowUpRight size={13} /></Link>
          {SITE.map(([h, l]) => <a key={h} href={h}>{l}<ArrowUpRight size={13} /></a>)}
        </nav>
        <div className="lp-foot-contact">
          <h4>Nous contacter</h4>
          <a href="tel:+33255997758" className="lp-foot-phone" data-testid="footer-phone"><Phone size={18} /><span><strong>02 55 99 77 58</strong><small><Clock size={11} /> de 10h à 18h</small></span></a>
          <a href="mailto:contact@airthermo.fr" className="lp-foot-line" data-testid="footer-email"><Mail size={15} />contact@airthermo.fr</a>
          <p className="lp-foot-line" data-testid="footer-address"><MapPin size={15} /><span>AIRTHERMO<br />5 allée de la Grande Treille<br />35200 Rennes</span></p>
          <a href="#etude" className="lp-btn lp-sm" data-testid="footer-cta">Demander mon étude<span className="lp-ico"><Arrow /></span></a>
        </div>
      </div>
      <div className="lp-foot-bottom">
        <span>© {new Date().getFullYear()} Airthermo — Cabinet de courtage énergie</span>
        <span className="lp-foot-links">
          <Link to="/mentions-legales" data-testid="footer-legal">Mentions légales</Link>
          <Link to="/politique-de-confidentialite" data-testid="footer-privacy">Politique de confidentialité</Link>
          <button type="button" onClick={openCookieSettings} data-testid="footer-cookies">Gérer les cookies</button>
        </span>
      </div>
    </div>
  </footer>
);
